import { commonRoutes } from './commonRoutes';

export const managementRoutes = {
  MANAGEMENT: '/mp',
  get LOGIN() {
    return `${this.MANAGEMENT}/${commonRoutes.LOGIN}`;
  },
  get FORGOT_PASSWORD() {
    return `${this.MANAGEMENT}/${commonRoutes.FORGOT_PASSWORD}`;
  },
  get CREATE_PASSWORD() {
    return `${this.MANAGEMENT}/${commonRoutes.CREATE_PASSWORD}`;
  },
  get RESET_PASSWORD() {
    return `${this.MANAGEMENT}/${commonRoutes.RESET_PASSWORD}`;
  },
  get DASHBOARD() {
    return `${this.MANAGEMENT}/${commonRoutes.DASHBOARD}`;
  },
  get PROFILE() {
    return `${this.MANAGEMENT}/${commonRoutes.PROFILE}`;
  },
  get UNIT_INQUIRY() {
    return `${this.MANAGEMENT}/unit-inquiry`;
  },
  get SUPPLY_NOTIFICATION_RESULT() {
    return `${this.MANAGEMENT}/supply-notification-result`;
  },
  get DISPATCH_NOTIFICATION_RESULTS() {
    return `${this.MANAGEMENT}/dispatch-notification-result`;
  },
  get UNDEFINED_UNIT_MOBILE() {
    return `${this.MANAGEMENT}/undefined-unit-mobile`;
  },
  get UNDEFINED_UNIT_SERVICE() {
    return `${this.MANAGEMENT}/undefined-unit-service`;
  },
  get SIDE_EFFECTS() {
    return `${this.MANAGEMENT}/side-effect`;
  },
  get EXPIRY_DATE_UPDATE() {
    return `${this.MANAGEMENT}/expiry-date-update`;
  },
  get BATCH_NUMBER_UPDATE() {
    return `${this.MANAGEMENT}/batch-number-update`;
  },
  get PARTIAL_BATCH_NUMBER_UPDATE() {
    return `${this.MANAGEMENT}/partial-batch-number-update`;
  },
  get MANAGEMENT_USERS() {
    return `${this.MANAGEMENT}/management-users`;
  },
  get MANAGEMENT_NEW_USER() {
    return `${this.MANAGEMENT_USERS}/new-management-user`;
  },
  get MANAGEMENT_EDIT_USER() {
    return `${this.MANAGEMENT_USERS}/edit-management-user`;
  },
  get SHs_USERS() {
    return `${this.MANAGEMENT}/stakeholder-users`;
  },
  get SH_NEW_USER() {
    return `${this.SHs_USERS}/add`;
  },
  get SH_EDIT_USER() {
    return `${this.SHs_USERS}/edit`;
  },
  get SHs() {
    return `${this.MANAGEMENT}/stakeholders`;
  },
  get EDIT_SH() {
    return `${this.SHs}/edit`;
  },
  get ADD_SH() {
    return `${this.SHs}/add`;
  },
  get SH_REQUESTS() {
    return `${this.MANAGEMENT}/stakeholder-requests`;
  },
  get EDIT_SH_REQUEST() {
    return `${this.SH_REQUESTS}/edit`;
  },
  get ESTABLISHMENTS() {
    return `${this.MANAGEMENT}/establishment`;
  },
  get ADD_ESTABLISHMENT() {
    return `${this.ESTABLISHMENTS}/add`;
  },
  get EDIT_ESTABLISHMENT() {
    return `${this.ESTABLISHMENTS}/edit`;
  },
  get DRUG_SHORTAGE() {
    return `${this.MANAGEMENT}/drug-shortage`;
  },

  get EDIT_DRUG_SHORTAGE() {
    return `${this.DRUG_SHORTAGE}/edit`;
  },
  get MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE() {
    return `${this.MANAGEMENT}/medical-establishment-drug-shortage`;
  },
  get SH_GRADES() {
    return `${this.MANAGEMENT}/stakeholder-grades`;
  },
  get DRUGS() {
    return `${this.MANAGEMENT}/${commonRoutes.DRUGS}`;
  },
  get UNREGISTERED_DRUGS_REQUESTS() {
    return `${this.MANAGEMENT}/${commonRoutes.UNREGISTERED_DRUGS_REQUESTS}`;
  },
  get ADD_DRUG() {
    return `${this.MANAGEMENT}/${commonRoutes.ADD_DRUG}`;
  },
  get EDIT_DRUG() {
    return `${this.MANAGEMENT}/${commonRoutes.EDIT_DRUG}`;
  },
  get EDIT_UN_REGISTERED_DRUG() {
    return `${this.MANAGEMENT}/${commonRoutes.EDIT_UN_REGISTERED_DRUG}`;
  },
  get DUPLICATE_DRUG() {
    return `${this.DRUGS}/duplicate`;
  },
  get HELP_DESK() {
    return `${this.MANAGEMENT}/help-desk`;
  },
  get VIEW_TICKET() {
    return `${this.HELP_DESK}/ticket`;
  },
  get CREATE_TICKET() {
    return `${this.HELP_DESK}/add`;
  },
  get MAIL_MANAGEMENT() {
    return `${this.MANAGEMENT}/mail-management`;
  },
  get MAIL_CONFIGS() {
    return `${this.MAIL_MANAGEMENT}/config`;
  },
  get RECALL_MANAGEMENT() {
    return `${this.MANAGEMENT}/recall-management`;
  },
  get VIEW_RECALL_NOTIFICATION() {
    return `${this.RECALL_MANAGEMENT}/view`;
  },
  get ADD_RECALL_NOTIFICATION() {
    return `${this.RECALL_MANAGEMENT}/add`;
  },
  get BLOCK_NOTIFICATIONS() {
    return `${this.MANAGEMENT}/block-notifications`;
  },
  get VIEW_BLOCK_NOTIFICATION_DETAILS() {
    return `${this.BLOCK_NOTIFICATIONS}/view`;
  },
  get ADD_BLOCK_NOTIFICATION() {
    return `${this.BLOCK_NOTIFICATIONS}/add`;
  },
  get ERROR_MESSAGES() {
    return `${this.MANAGEMENT}/error-messagessd`;
  },
  get ANNOUNCEMENTS() {
    return `${this.MANAGEMENT}/announcements`;
  },
  get ADD_ANNOUNCEMENT() {
    return `${this.ANNOUNCEMENTS}/add`;
  },
  get EDIT_ANNOUNCEMENT() {
    return `${this.ANNOUNCEMENTS}/edit`;
  },
  get SYSTEM_STATUS() {
    return `${this.MANAGEMENT}/system-status`;
  },
  get SYSTEM_PARAM() {
    return `${this.MANAGEMENT}/system-parameters`;
  },
  get MONTHLY_DRUG_SALE_LIMITATION() {
    return `${this.MANAGEMENT}/monthly-drug-sale-limitation`;
  },
  get ADD_MONTHLY_DRUG_SALE_LIMITATION() {
    return `${this.MANAGEMENT}/${this.MONTHLY_DRUG_SALE_LIMITATION}/add`;
  },
  get EDIT_MONTHLY_DRUG_SALE_LIMITATION() {
    return `${this.MANAGEMENT}/${this.MONTHLY_DRUG_SALE_LIMITATION}/edit`;
  },
  get DEACTIVATION_REASON_MATRIX() {
    return `${this.MANAGEMENT}/deactivation-reason-matrix`;
  },
  get STATUS_MATRIX() {
    return `${this.MANAGEMENT}/status-matrix`;
  },
  get DEMAND_OPERATIONS() {
    return `${this.MANAGEMENT}/demand-operation`;
  },
  get OFFER_OPERATIONS() {
    return `${this.MANAGEMENT}/offer-operation`;
  },
  get EDIT_OFFER() {
    return `${this.OFFER_OPERATIONS}/edit`;
  },
  get EDIT_DEMAND() {
    return `${this.DEMAND_OPERATIONS}/edit`;
  },
  get DEMANDS_OFFER_CHAT_History() {
    return `${this.DEMAND_OPERATIONS}/offer-demands-chat-history`;
  },
  get REPORT() {
    return `${this.MANAGEMENT}/report`;
  },
  get NOTIFICATION_LOGLIST() {
    return `${this.REPORT}/notification-loglist`;
  },
  get WEBSERVICE_LOGLIST() {
    return `${this.REPORT}/webservices-loglist`;
  },
  get STAKEHOLDER_OPERATION_SOURCE() {
    return `${this.REPORT}/stakeholder-operation-source-list`;
  },
  get PHARMACY_SALE_REPORT() {
    return `${this.REPORT}/pharmacy-sale-report`;
  },
  get DRUG_SH_LIST() {
    return `${this.REPORT}/drug-stakeholder-list`;
  },
  get DRUG_COUNT_OVER_SH_TYPE() {
    return `${this.REPORT}/drug-count-over-stakeholder-type`;
  },
  get DRUG_COUNT_OVER_SH() {
    return `${this.REPORT}/drug-count-over-stakeholder`;
  },
  get DRUG_LIST_OVER_SH() {
    return `${this.REPORT}/drug-list-over-stakeholder`;
  },
  get EXPIRED_DRUG_LIST() {
    return `${this.REPORT}/expired-drug-list`;
  },
  get BLOCKED_DRUG_COUNT_LIST() {
    return `${this.REPORT}/blocked-drug-count-list`;
  },
  get BLOCKED_DRUG_LIST() {
    return `${this.REPORT}/blocked-drug-list`;
  },
  get BLOCKED_DRUGS() {
    return `${this.REPORT}/blocked-drugs`;
  },
  get GENERAL_BLOCKED_DRUGS() {
    return `${this.REPORT}/general-blocked-drugs`;
  },
  get RECALLED_DRUG_COUNT_LIST() {
    return `${this.REPORT}/recalled-drug-count-list`;
  },
  get RECALLED_DRUGS_LIST() {
    return `${this.REPORT}/recalled-drugs-list`;
  },
  get RECALLED_DRUGS() {
    return `${this.REPORT}/recalled-drugs`;
  },
  get GENERAL_RECALLED_DRUGS() {
    return `${this.REPORT}/general-recalled-drugs`;
  },
  get NON_SUPPLIED_DRUG_LIST() {
    return `${this.REPORT}/non-supplied-drug-list`;
  },
  get SIDE_EFFECT_COUNT_LIST() {
    return `${this.REPORT}/side-effect-count-list`;
  },
  get ZERO_STOCK_DRUG() {
    return `${this.REPORT}/zero-stock-drug`;
  },
  get DRUG_STATUS_REPORT() {
    return `${this.REPORT}/drug-status-report`;
  },
  get GENERAL_DRUG_STATUS_LIST() {
    return `${this.REPORT}/general-drug-status-list`;
  },
  get SUPPLIED_DRUG_LIST() {
    return `${this.REPORT}/supplied-drug-list`;
  },
  get GENERAL_SUPPLIED_DRUG_LIST() {
    return `${this.REPORT}/general-supplied-drug-list`;
  },
  get BATCH_STATUS_LIST() {
    return `${this.REPORT}/batch-status-list`;
  },
  get DRUG_LIST_OVER_SERIAL_NUMBER() {
    return `${this.REPORT}/drug-list-over-serial-number`;
  },
  get DRUG_COUNT_OVER_REGISTRATION_NUMBER() {
    return `${this.REPORTS}/drug-count-over-registration-number`;
  },
  get UNITS() {
    return `${this.MANAGEMENT}/units`;
  },
  get USERS() {
    return `${this.MANAGEMENT}/users`;
  },
  get STAKEHOLDERS() {
    return `${this.MANAGEMENT}/stakeholders2`;
  },
  get INCENTIVE_MANAGEMENT() {
    return `${this.MANAGEMENT}/incentive-management`;
  },
  get PORTAL() {
    return `${this.MANAGEMENT}/portal`;
  },
  get SYSTEM_MANAGEMENT() {
    return `${this.MANAGEMENT}/system-management`;
  },
  get OFFER_DEMAND_OPERATIONS() {
    return `${this.MANAGEMENT}/offer-demand-operations`;
  },
  get REPORTS() {
    return `${this.MANAGEMENT}/reports`;
  },
  get UPDATE_PROFILE() {
    return `${this.MANAGEMENT}/${commonRoutes.UPDATE_PROFILE}`;
  },
  get ADD_BLACKLIST() {
    return `${this.BLACKLIST}/add`;
  },
  get SUBSCRIBED_LIST() {
    return `${this.MANAGEMENT}/subscribed-list`;
  },
  get ADD_STAKEHOLDER_SUBSCRIPTION() {
    return `${this.MANAGEMENT}/Add-Stakeholder-Subscription`;
  },
  get MANUFACTURE_DATE_UPDATE() {
    return `${this.MANAGEMENT}/manufacture-date-update`;
  },
  get GLN_UPDATE() {
    return `${this.MANAGEMENT}/gln-update`;
  },
  get SUBSCRIPTIONS_REPORT() {
    return `${this.MANAGEMENT}/subscriptions-report`;
  },
  get SUBSCRIPTION_OPERATIONS_REPORT() {
    return `${this.MANAGEMENT}/SubscriptionOperationsReport`;
  },
  get STOCK_MATCH_OPERATIONS_REPORT() {
    return `${this.MANAGEMENT}/StockMatchOperationsReport`;
  },
  get UNREGISTERED_DRUG_OPERATIONS_REPORT() {
    return `${this.MANAGEMENT}/UnregisteredDrugOperationsReport`;
  },
  get REDISTRIBUTION_OPERATIONS() {
    return `${this.MANAGEMENT}/redistribution`;
  },
  get REDISTRIBUTION_DEMAND_LIST() {
    return `${this.REDISTRIBUTION_OPERATIONS}/demand-list`;
  },
  get REDISTRIBUTION_DEMAND_DETAILS() {
    return `${this.REDISTRIBUTION_OPERATIONS}/demand-details`;
  },
  get LABELS() {
    return `${this.MANAGEMENT}/labels`;
  },
  get ADD_LABELS() {
    return `${this.LABELS}/add`;
  },
  get EDIT_LABELS() {
    return `${this.LABELS}/edit`;
  },
  get MP_STOCK_MATCH_LOG_LIST() {
    return `${this.MANAGEMENT}/stock-match-log-list`;
  },
  get MP_STOCK_MATCH_LOG_DETAILS() {
    return `${this.MP_STOCK_MATCH_LOG_LIST}/:id`;
  }
};

export const ManagementBreadcrumbTitlesKey = {
  [managementRoutes.MANAGEMENT]: 'pageTitles.ManagementPortal',
  [managementRoutes.DASHBOARD]: 'pageTitles.dashboard',
  [managementRoutes.DRUGS]: 'pageTitles.drugs',
  [managementRoutes.UNREGISTERED_DRUGS_REQUESTS]: 'pageTitles.unRegisteredDrugsRequests',
  [managementRoutes.EDIT_DRUG]: 'pageTitles.editDrug',
  [managementRoutes.EDIT_UN_REGISTERED_DRUG]: 'pageTitles.editDrug',
  [managementRoutes.DUPLICATE_DRUG]: 'pageTitles.duplicateDrug',
  [managementRoutes.ADD_DRUG]: 'pageTitles.newDrug',
  [managementRoutes.MANAGEMENT_USERS]: 'pageTitles.managementUsers',
  [managementRoutes.MANAGEMENT_NEW_USER]: 'pageTitles.newManagementUser',
  [managementRoutes.MONTHLY_DRUG_SALE_LIMITATION]: 'pageTitles.monthlyDrugSaleLimitation',
  [managementRoutes.ADD_MONTHLY_DRUG_SALE_LIMITATION]: 'pageTitles.addMonthlyDrugSaleLimitation',
  [managementRoutes.ESTABLISHMENTS]: 'pageTitles.establishments',
  [managementRoutes.MANAGEMENT_EDIT_USER]: 'pageTitles.editUser',
  [managementRoutes.SHs_USERS]: 'pageTitles.stakeholderUsers',
  [managementRoutes.MANAGEMENT_NEW_USER]: 'pageTitles.newUser',
  [managementRoutes.SUPPLY_NOTIFICATION_RESULT]: 'pageTitles.supplyNotificationResult',
  [managementRoutes.SH_NEW_USER]: 'pageTitles.newUser',
  [managementRoutes.SHs]: 'pageTitles.stakeholders',
  [managementRoutes.ADD_SH]: 'pageTitles.newStakeholder',
  [managementRoutes.EDIT_SH]: 'pageTitles.edit',
  [managementRoutes.MAIL_MANAGEMENT]: 'pageTitles.mailManagement',
  [managementRoutes.SH_EDIT_USER]: 'pageTitles.edit',
  [managementRoutes.HELP_DESK]: 'pageTitles.helpDesk',
  [managementRoutes.VIEW_TICKET]: 'pageTitles.ticket',
  [managementRoutes.NEW_TICKET]: 'pageTitles.newTicket',
  [managementRoutes.PROFILE]: 'pageTitles.profile',
  [managementRoutes.UNIT_INQUIRY]: 'pageTitles.unitInquiry',
  [managementRoutes.SUPPLY_NOTIFICATION_RESULT]: 'pageTitles.supplyNotificationResult',
  [managementRoutes.DISPATCH_NOTIFICATION_RESULTS]: 'pageTitles.dispatchNotificationResults',
  [managementRoutes.UNDEFINED_UNIT_MOBILE]: 'pageTitles.undefinedUnitMobile',
  [managementRoutes.UNDEFINED_UNIT_SERVICE]: 'pageTitles.undefinedUnitService',
  [managementRoutes.SIDE_EFFECTS]: 'pageTitles.sideEffect',
  [managementRoutes.EXPIRY_DATE_UPDATE]: 'pageTitles.expiryDateUpdate',
  [managementRoutes.BATCH_NUMBER_UPDATE]: 'pageTitles.batchNumberUpdate',
  [managementRoutes.MANUFACTURE_DATE_UPDATE]: 'pageTitles.manufactureDateUpdate',
  [managementRoutes.PARTIAL_BATCH_NUMBER_UPDATE]: 'pageTitles.partialBatchNumberUpdate',
  [managementRoutes.SH_REQUESTS]: 'pageTitles.stakeholderRequests',
  [managementRoutes.EDIT_SH_REQUEST]: 'pageTitles.edit',
  [managementRoutes.ADD_ESTABLISHMENT]: 'pageTitles.add',
  [managementRoutes.EDIT_ESTABLISHMENT]: 'pageTitles.edit',
  [managementRoutes.DRUG_SHORTAGE]: 'pageTitles.drugShortage',
  [managementRoutes.EDIT_DRUG_SHORTAGE]: 'pageTitles.edit',
  [managementRoutes.MEDICAL_ESTABLISHMENT_DRUG_SHORTAGE]: 'pageTitles.medicalEstablishmentDrugShortage',
  [managementRoutes.SH_GRADES]: 'pageTitles.stakeholderGrades',
  [managementRoutes.RECALL_MANAGEMENT]: 'pageTitles.recallNotifications',
  [managementRoutes.VIEW_RECALL_NOTIFICATION]: 'pageTitles.view',
  [managementRoutes.ADD_RECALL_NOTIFICATION]: 'pageTitles.add',
  [managementRoutes.BLOCK_NOTIFICATIONS]: 'pageTitles.blockNotifications',
  [managementRoutes.VIEW_BLOCK_NOTIFICATION_DETAILS]: 'pageTitles.view',
  [managementRoutes.ADD_BLOCK_NOTIFICATION]: 'pageTitles.add',
  [managementRoutes.ERROR_MESSAGES]: 'pageTitles.errorMessages',
  [managementRoutes.ANNOUNCEMENTS]: 'pageTitles.announcement&news',
  [managementRoutes.ADD_ANNOUNCEMENT]: 'pageTitles.add',
  [managementRoutes.EDIT_ANNOUNCEMENT]: 'pageTitles.edit',
  [managementRoutes.SYSTEM_STATUS]: 'pageTitles.systemStatusMonitor',
  [managementRoutes.SYSTEM_PARAM]: 'pageTitles.systemParameters',
  [managementRoutes.DEACTIVATION_REASON_MATRIX]: 'pageTitles.deactivationReasonMatrix',
  [managementRoutes.STATUS_MATRIX]: 'pageTitles.statusMatrix',
  [managementRoutes.DEMAND_OPERATIONS]: 'pageTitles.demandOperations',
  [managementRoutes.EDIT_OFFER]: 'pageTitles.edit',
  [managementRoutes.REPORT]: 'pageTitles.reports',
  [managementRoutes.NOTIFICATION_LOGLIST]: 'pageTitles.notificationLogList',
  [managementRoutes.WEBSERVICE_LOGLIST]: 'pageTitles.webserviceLogList',
  [managementRoutes.STAKEHOLDER_OPERATION_SOURCE]: 'pageTitles.stakeholderOperationSourceList',
  [managementRoutes.PHARMACY_SALE_REPORT]: 'pageTitles.pharmacySaleReport',
  [managementRoutes.DRUG_SH_LIST]: 'pageTitles.drugStakeholderList',
  [managementRoutes.DRUG_COUNT_OVER_SH_TYPE]: 'pageTitles.drugCountOverStakeholderType',
  [managementRoutes.DRUG_COUNT_OVER_SH]: 'pageTitles.drugCountOverStakeholder',
  [managementRoutes.DRUG_LIST_OVER_SH]: 'pageTitles.drugListOverStakeholder',
  [managementRoutes.EXPIRED_DRUG_LIST]: 'pageTitles.expiredDrugList',
  [managementRoutes.BLOCKED_DRUG_COUNT_LIST]: 'pageTitles.blockedDrugCountList',
  [managementRoutes.BLOCKED_DRUG_LIST]: 'pageTitles.blockedDrugList',
  [managementRoutes.BLOCKED_DRUGS]: 'pageTitles.blockedDrugs',
  [managementRoutes.GENERAL_BLOCKED_DRUGS]: 'pageTitles.generalBlockedDrugs',
  [managementRoutes.RECALLED_DRUG_COUNT_LIST]: 'pageTitles.recalledDrugCountList',
  [managementRoutes.RECALLED_DRUGS_LIST]: 'pageTitles.recalledDrugList',
  [managementRoutes.RECALLED_DRUGS]: 'pageTitles.recalledDrugs',
  [managementRoutes.GENERAL_RECALLED_DRUGS]: 'pageTitles.generalRecalledDrugs',
  [managementRoutes.NON_SUPPLIED_DRUG_LIST]: 'pageTitles.nonSuppliedDrugList',
  [managementRoutes.SIDE_EFFECT_COUNT_LIST]: 'pageTitles.sideEffectCountList',
  [managementRoutes.ZERO_STOCK_DRUG]: 'pageTitles.zeroStockDrugs',
  [managementRoutes.DRUG_STATUS_REPORT]: 'pageTitles.drugStatusReport',
  [managementRoutes.GENERAL_DRUG_STATUS_LIST]: 'pageTitles.generalDrugStatusList',
  [managementRoutes.SUPPLIED_DRUG_LIST]: 'pageTitles.suppliedDrugList',
  [managementRoutes.GENERAL_SUPPLIED_DRUG_LIST]: 'pageTitles.generalSuppliedDrugList',
  [managementRoutes.BATCH_STATUS_LIST]: 'pageTitles.batchStatusList',
  [managementRoutes.DRUG_COUNT_OVER_REGISTRATION_NUMBER]: 'pageTitles.drugCountOverRegistrationNumber',
  [managementRoutes.DRUG_COUNT_OVER_REGISTRATION_NUMBER]: 'pageTitles.drugCountOverRegistrationNumber',
  [managementRoutes.UNITS]: 'pageTitles.units',
  [managementRoutes.USERS]: 'pageTitles.users',
  [managementRoutes.STAKEHOLDERS]: 'pageTitles.stakeholders',
  [managementRoutes.INCENTIVE_MANAGEMENT]: 'pageTitles.incentiveManagement',
  [managementRoutes.PORTAL]: 'pageTitles.portal',
  [managementRoutes.SYSTEM_MANAGEMENT]: 'pageTitles.systemManagement',
  [managementRoutes.OFFER_DEMAND_OPERATIONS]: 'pageTitles.offerDemandOperations',
  [managementRoutes.REPORTS]: 'pageTitles.reports',
  [managementRoutes.CREATE_TICKET]: 'pageTitles.newTicket',
  [managementRoutes.BLACKLIST]: 'sideMenu.manageBlacklistUsers',
  [managementRoutes.ADD_BLACKLIST]: 'btns.addBlacklistUser',
  [managementRoutes.DEMANDS_OFFER_CHAT_History]: 'pageTitles.RSDChat',
  [managementRoutes.UPDATE_PROFILE]: 'pageTitles.ManagementPortalUpdateProfile',
  [managementRoutes.SUBSCRIBED_LIST]: 'pageTitles.subscribedList',
  [managementRoutes.ADD_STAKEHOLDER_SUBSCRIPTION]: 'pageTitles.addStakeholder',
  [managementRoutes.DRUG_LIST_OVER_SERIAL_NUMBER]: 'pageTitles.drugListOverSerialNumber',
  [managementRoutes.GLN_UPDATE]: 'pageTitles.glnUpdate',
  [managementRoutes.SUBSCRIPTIONS_REPORT]: 'pageTitles.subscriptionsReport',
  [managementRoutes.SUBSCRIPTION_OPERATIONS_REPORT]: 'pageTitles.SubscriptionOperationsReport',
  [managementRoutes.STOCK_MATCH_OPERATIONS_REPORT]: 'pageTitles.StockMatchOperationsReport',
  [managementRoutes.UNREGISTERED_DRUG_OPERATIONS_REPORT]: 'pageTitles.unregisteredDrugOperationsReport',
  [managementRoutes.REDISTRIBUTION_OPERATIONS]: 'pageTitles.redistributionOperations',
  [managementRoutes.REDISTRIBUTION_DEMAND_LIST]: 'pageTitles.redistributionDemandList',
  [managementRoutes.REDISTRIBUTION_DEMAND_DETAILS]: 'pageTitles.redistributionDemandDetails',
  [managementRoutes.LABELS]: 'pageTitles.labels',
  [managementRoutes.ADD_LABELS]: 'pageTitles.addNewLabel',
  [managementRoutes.EDIT_LABELS]: 'pageTitles.editLabel',
  [managementRoutes.MP_STOCK_MATCH_LOG_LIST]: 'pageTitles.stockMatchLogList',
  [managementRoutes.MP_STOCK_MATCH_LOG_DETAILS]: 'pageTitles.stockMatchLogDetails'
};

